import { render } from "./address-selector.vue?vue&type=template&id=a4922e6e&ts=true"
import script from "./address-selector.vue?vue&type=script&lang=ts"
export * from "./address-selector.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__